import React, { FC } from 'react';
import { IHeaderImages, ImagePageHeader } from '../../../shared/components';
import { PageLayout } from '../../../shared/layout/page/PageLayout';
import { Sections } from '../../../content-sections/ui';
import { IEnrichedPageEntry } from '../domain/models/IEnrichedPageEntry';

export type IGenericLandingPageProps = {
	page: IEnrichedPageEntry;
	headerImages: IHeaderImages;
};

export const GenericLandingPage: FC<IGenericLandingPageProps> = ({
	page,
	headerImages,
}) => (
	<PageLayout page={page}>
		<ImagePageHeader page={page} images={headerImages} />
		{page.fields.sections && <Sections sections={page.fields.sections} />}
	</PageLayout>
);
